import { buildProps as e } from "./index601.js";
import { iconPropType as o } from "./index606.js";
const a = e({
  /**
   * @description whether to align the header and footer in center
   */
  center: Boolean,
  /**
   * @description whether to align the dialog both horizontally and vertically
   */
  alignCenter: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description custom close icon, default is Close
   */
  closeIcon: {
    type: o
  },
  /**
   * @description enable dragging feature for Dialog
   */
  draggable: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description draggable Dialog can overflow the viewport
   */
  overflow: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description whether the Dialog takes up full screen
   */
  fullscreen: Boolean,
  /**
   * @description custom class names for header wrapper
   */
  headerClass: String,
  /**
   * @description custom class names for body wrapper
   */
  bodyClass: String,
  /**
   * @description custom class names for footer wrapper
   */
  footerClass: String,
  /**
   * @description whether to show a close button
   */
  showClose: {
    type: Boolean,
    default: !0
  },
  /**
   * @description title of Dialog. Can also be passed with a named slot (see the following table)
   */
  title: {
    type: String,
    default: ""
  },
  /**
   * @description header's aria-level attribute
   */
  ariaLevel: {
    type: String,
    default: "2"
  }
}), n = {
  close: () => !0
};
export {
  n as dialogContentEmits,
  a as dialogContentProps
};
